export default __webpack_public_path__ + "static/info-55a606b94042eb7935be9c44574b83f2.jpg";